var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmWatsonDiscovery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ibm-watson--discovery_svg__clip0_61530_7288)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.75h-6v1.5h6v-1.5zM2.25 14.25a.75.75 0 100-1.5.75.75 0 000 1.5zM9.75 11.25a.75.75 0 100-1.5.75.75 0 000 1.5zM7.5 9.75h-6v1.5h6v-1.5zM10.5 6.75h-6v1.5h6v-1.5zM2.25 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.502 21.45l-5.55-5.55a8.985 8.985 0 001.8-5.4c0-4.95-4.05-9-9-9-2.475 0-4.8.975-6.525 2.85L4.352 5.4c1.35-1.575 3.3-2.4 5.4-2.4 4.125 0 7.5 3.375 7.5 7.5s-3.375 7.5-7.5 7.5c-2.25 0-4.35-.975-5.775-2.7l-1.125.975c1.65 2.025 4.2 3.225 6.9 3.225 2.4 0 4.575-.975 6.225-2.475l5.475 5.475 1.05-1.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ibm-watson--discovery_svg__clip0_61530_7288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIbmWatsonDiscovery;